"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.s = exports.RootListDark = exports.RootList = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var styles = function styles() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("list-style-type:none;margin:0;padding:0;")
  );
};

var stylesDark = function stylesDark() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("list-style-type:none;margin:0;padding:0;background-color:", _themeConfig.default.color.dark.saturn, ";")
  );
};

var item = function item(activityLine) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;position:relative;", activityLine && "\n    overflow: hidden;\n    margin-bottom: 28px;\n  ")
  );
};

var lineWrapper = function lineWrapper() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;flex-direction:column;")
  );
};

var line = function line(theme, index, lastIndex, activityLine) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("border:1px solid ", theme.color.grey2, ";top:", index === 0 ? '50%' : '0', ";position:absolute;height:100%;width:0;left:10px;", activityLine && 'left: 20px;', "\n  ", lastIndex && "\n    bottom: 50%;\n    height: 50%;\n  ", "\n  ", activityLine && "\n    top: 60px;\n    height: 100%;\n    @media (max-width: 767px) {\n      left: 15px;\n    }\n  ")
  );
};

var darkLine = function darkLine(theme, index, lastIndex, completed) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("border:1px solid ", theme.color.dark.sapphire, ";position:absolute;height:100%;top:", index === 0 ? '27px' : '27px', ";width:0;left:10px;", lastIndex && "\n    height: 0%;\n  ", "\n  ", completed && "\n    border: 1px solid ".concat(theme.color.dark.emerald, ";\n  "))
  );
};

var circle = function circle(theme, completed, darkMode) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("border:1px solid ", theme.color.accent, ";min-height:20px;min-width:20px;max-height:20px;max-width:20px;z-index:2;border-radius:50%;position:absolute;background-color:", completed ? theme.color.accent : theme.color.white, ";text-align:center;", darkMode && "\n    background-color: ".concat(theme.color.dark.sapphire, ";\n    border: 1px solid ").concat(theme.color.dark.sapphire, ";\n    margin-left: 5px;\n    margin-top: 27px;\n    min-height: 11px;\n    min-width: 11px;\n    max-height: 11px;\n    max-width: 11px; \n  "), "\n  ", darkMode && completed && "\n    border: 1px solid ".concat(theme.color.dark.emerald, ";\n    margin-left: 0px;\n    background-color: ").concat(theme.color.dark.saturn, ";\n    min-height: 21px;\n    min-width: 21px;\n    max-height: 21px;\n    max-width: 21px; \n  "), "\n  ", !darkMode && "\n    margin-top: -11px;\n    top: 50%;\n  ")
  );
};

var userCircle = function userCircle(theme, img) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("background:url(", img, ") center center no-repeat;background-size:cover;min-height:40px;min-width:40px;max-height:40px;max-width:40px;border:none;text-align:center;border-radius:50%;position:absolute;@media (max-width:767px){min-height:30px;min-width:30px;max-height:30px;max-width:30px;}")
  );
};

var content = function content(activityLine, darkMode) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(darkMode && "\n    color: ".concat(_themeConfig.default.color.dark.copper, ";\n  "), "\n  padding:23px 46px;@media (max-width:767px){padding:23px 36px;}", activityLine && "\n    padding-top: 0;\n    padding-right: 0;\n    padding-left: 46px;\n    padding-bottom: 0;\n    width: 100%;\n    @media (max-width: 767px) {\n      padding-left: 36px;\n      padding-top: 0px;\n      padding-right: 0px;\n      padding-bottom: 0px;\n    }\n  ")
  );
};

var icon = function icon(theme, darkMode) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("fill:", theme.color.white, ";margin-top:-2px;", darkMode && "\n    fill: ".concat(theme.color.dark.emerald, ";\n    margin-top: 0px;\n  "))
  );
};

var userImage = function userImage(img) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("background:url(", img, ");")
  );
};

var activityTitle = function activityTitle() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("min-height:40px;max-height:40px;overflow:hidden;margin-bottom:20px;")
  );
};

var RootList = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("ul", {
  target: "css-ro9y6e0"
})(styles));
exports.RootList = RootList;
var RootListDark = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("ul", {
  target: "css-ro9y6e1"
})(stylesDark));
exports.RootListDark = RootListDark;
var s = {
  circle: circle,
  item: item,
  content: content,
  line: line,
  darkLine: darkLine,
  lineWrapper: lineWrapper,
  icon: icon,
  userImage: userImage,
  userCircle: userCircle,
  RootListDark: RootListDark,
  activityTitle: activityTitle
};
exports.s = s;